module.exports = __webpack_public_path__ + "img/scene13.cc95f9f7.gif";